import { routes } from 'utils/routing';

import type { RawTab } from '../../types';

export const id: RawTab['id'] = 'menu';

export const link: RawTab['link'] = {
  en: routes.menu,
  fr: routes.menu,
};
